import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../ui';

const StatCard = ({ title, value, change, changeLabel, iconName, color, onClick }) => {
  const colors = {
    blue: { bg: 'bg-blue-50', icon: 'text-blue-600', text: 'text-blue-700' },
    green: { bg: 'bg-green-50', icon: 'text-green-600', text: 'text-green-700' },
    purple: { bg: 'bg-purple-50', icon: 'text-purple-600', text: 'text-purple-700' },
    red: { bg: 'bg-red-50', icon: 'text-red-600', text: 'text-red-700' },
  };

  const selectedColor = colors[color] || colors.blue;

  return (
    <div 
      onClick={onClick}
      className="bg-white rounded-xl shadow-sm border p-6 hover:shadow-md transition-shadow cursor-pointer"
    >
      <div className="flex items-center justify-between mb-4">
        <div className={`p-3 ${selectedColor.bg} rounded-lg`}>
          {iconName && <Icon name={iconName} size={20} className={selectedColor.icon} />}
        </div>
        {change !== undefined && (
          <div className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
            change >= 0 ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
          }`}>
            <Icon name={change >= 0 ? 'IconArrowUp' : 'IconArrowDown'} size={12} className="mr-1" />
            {Math.abs(change).toFixed(1)}%
          </div>
        )}
      </div>
      <h3 className="text-2xl font-bold text-gray-900 mb-1">{value}</h3>
      <p className="text-gray-600">{title}</p>
      {changeLabel && (
        <p className="text-sm text-gray-400 mt-2">{changeLabel}</p>
      )}
    </div>
  );
};

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  change: PropTypes.number,
  changeLabel: PropTypes.string,
  iconName: PropTypes.string,
  color: PropTypes.oneOf(['blue', 'green', 'purple', 'red', 'orange', 'indigo', 'gray']),
  onClick: PropTypes.func,
  loading: PropTypes.bool,
  trend: PropTypes.oneOf(['up', 'down'])
};

StatCard.defaultProps = {
  color: 'blue',
  loading: false
};

export default StatCard;